import { useAccount } from "@vojomo-core/shared";
import { OperatingLayout } from "../../../layouts/operating/OperatingLayout";
import { getMemberData } from "../../../utils/helpers/getMemberData";
import { useEffect, useState } from "react";

export const OperatingPlatform = () => {
  const { companyName } = useAccount();
  const [memberPlatformLink, setMemberPlatformLink] = useState("");

  useEffect(() => {
    getMemberData(companyName).then((memberInfo) => {
      if (memberInfo !== null) {
        const memberLink: string = memberInfo.member_platform_link;
        setMemberPlatformLink(memberLink);
      }
    });
  }, [companyName]);

  const iframeEl = memberPlatformLink ? (
    <iframe
      style={{
        borderRadius: "10px",
        borderColor: "grey",
        borderWidth: "1px",
        borderStyle: "solid",
        width: "100%",
        height: "75vh"
      }}
      src={memberPlatformLink}
    />
  ) : (
    <></>
  );
  return <OperatingLayout pageHeader="Roadmap">{iframeEl}</OperatingLayout>;
};
